module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cb829a2cfd400567d459977c7e3f915b.png";